import React from 'react';
import {
  C,
  ANIMATED_OVERLAY_MAIN_VIEW_W,
  ANIMATED_OVERLAY_MAIN_VIEW_H,
  nx,
  ny,
} from '../flowCanvas.constants';

const HEADER_H = 40;
const LABEL_X = 12;
const CONTROL_X = 58;
const CONTROL_W = ANIMATED_OVERLAY_MAIN_VIEW_W - CONTROL_X - 12;
const ROW_Y = HEADER_H + 10;

const STYLE_OPTIONS = [
  { value: 'full-screen', label: 'Full Screen' },
  { value: 'bottom-1-3', label: 'Bottom 1/3' },
  { value: 'bottom-1-6', label: 'Bottom 1/6' },
  { value: 'left-side', label: 'Left Side' },
  { value: 'right-side', label: 'Right Side' },
  { value: 'top-left', label: 'Top Left' },
  { value: 'top-middle', label: 'Top Middle' },
  { value: 'top-right', label: 'Top Right' },
];

function getSelectedStyle(step, liveCustomisationData) {
  const cfg = step?.customisationConfig;
  const tabKey = cfg?.tabKey;
  const varKey = cfg?.varKey;
  const varName = cfg?.variables?.[0]?.variableName;
  const live = tabKey && varKey && varName
    ? liveCustomisationData?.[tabKey]?.[varKey]?.[varName]
    : null;
  const vals = Array.isArray(live)
    ? live
    : (step?.populatedData?.variables?.[0]?.allValues || []);
  return vals?.[0]?.selected ?? 'full-screen';
}

function SelectControl({ x, y, value, options, onChange }) {
  return (
    <foreignObject x={x} y={y} width={CONTROL_W} height="24" style={{ pointerEvents: 'auto' }}>
      <select
        value={value}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation();
          onChange?.(e.target.value);
        }}
        style={{
          width: '100%',
          height: '22px',
          borderRadius: '11px',
          border: '1px solid rgba(145,70,255,0.35)',
          background: 'rgba(145,70,255,0.10)',
          color: '#ffffff',
          fontSize: '9px',
          fontWeight: 700,
          padding: '0 8px',
          outline: 'none',
          boxSizing: 'border-box',
          cursor: 'pointer',
        }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} style={{ background: '#1a1a2e', color: '#fff' }}>
            {opt.label}
          </option>
        ))}
      </select>
    </foreignObject>
  );
}

export default function AnimatedOverlayMainViewNode({
  step,
  selected,
  onClick,
  centreY,
  overrideX,
  overrideY,
  liveCustomisationData,
  onFieldChange,
}) {
  const x = overrideX ?? nx(step);
  const y = overrideY ?? ny(step, centreY);
  const left = x - ANIMATED_OVERLAY_MAIN_VIEW_W / 2;
  const top = y - ANIMATED_OVERLAY_MAIN_VIEW_H / 2;
  const selectedStyle = getSelectedStyle(step, liveCustomisationData);

  return (
    <g className="fc-node fc-node--animated-overlay-main-view" onClick={onClick} style={{ cursor: 'pointer' }}>
      <rect
        x={left + 2}
        y={top + 4}
        width={ANIMATED_OVERLAY_MAIN_VIEW_W}
        height={ANIMATED_OVERLAY_MAIN_VIEW_H}
        rx="10"
        fill="#000"
        fillOpacity="0.3"
      />
      <rect
        x={left}
        y={top}
        width={ANIMATED_OVERLAY_MAIN_VIEW_W}
        height={ANIMATED_OVERLAY_MAIN_VIEW_H}
        rx="10"
        fill={selected ? C.cardSel : C.card}
        stroke={selected ? C.sel : C.purple}
        strokeWidth={selected ? 2 : 1.5}
      />
      <line
        x1={left + 1}
        y1={top + HEADER_H}
        x2={left + ANIMATED_OVERLAY_MAIN_VIEW_W - 1}
        y2={top + HEADER_H}
        stroke={C.border}
        strokeWidth="1"
      />

      <text
        x={left + 14}
        y={top + 25}
        fontSize="11.5"
        fontWeight="700"
        fill={C.text}
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        {step.stepTitle || 'Main View'}
      </text>

      <text
        x={left + LABEL_X}
        y={top + ROW_Y + 14}
        fontSize="9"
        fontWeight="700"
        fill={C.textMuted}
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        Style
      </text>

      <SelectControl
        x={left + CONTROL_X}
        y={top + ROW_Y}
        value={selectedStyle}
        options={STYLE_OPTIONS}
        onChange={(value) => onFieldChange?.('selected', value)}
      />
    </g>
  );
}
